export const holidays = {
  "2026-01-01": {
      "description": [
          "Hari libur nasional"
      ],
      "holiday": true,
      "summary": [
          "Hari Tahun Baru"
      ]
  },
  "2026-01-16": {
      "description": [
          "Hari libur nasional"
      ],
      "holiday": true,
      "summary": [
          "Isra Mikraj Nabi Muhammad"
      ]
  },
  "2026-02-16": {
      "description": [
          "Hari libur nasional"
      ],
      "holiday": true,
      "summary": [
          "Cuti Bersama Tahun Baru Imlek"
      ]
  },
  "2026-02-17": {
      "description": [
          "Hari libur nasional"
      ],
      "holiday": true,
      "summary": [
          "Tahun Baru Imlek"
      ]
  },
  "2026-02-20": {
      "description": [
          "Perayaan"
      ],
      "holiday": false,
      "summary": [
          "1 Ramadan (belum pasti)"
      ]
  },
  "2026-03-18": {
      "description": [
          "Hari libur nasional"
      ],
      "holiday": true,
      "summary": [
          "Cuti Bersama Hari Suci Nyepi (Tahun Baru Saka)"
      ]
  },
  "2026-03-19": {
      "description": [
          "Hari libur nasional"
      ],
      "holiday": true,
      "summary": [
          "Hari Suci Nyepi (Tahun Baru Saka)"
      ]
  },
  "2026-03-20": {
      "description": [
          "Hari libur nasional"
      ],
      "holiday": true,
      "summary": [
          "Cuti Bersama Idul Fitri"
      ]
  },
  "2026-03-21": {
      "description": [
          "Hari libur nasional"
      ],
      "holiday": true,
      "summary": [
          "Hari Idul Fitri (belum pasti)"
      ]
  },
  "2026-03-22": {
      "description": [
          "Hari libur nasional"
      ],
      "holiday": true,
      "summary": [
          "Hari Idul Fitri (belum pasti)"
      ]
  },
  "2026-03-23": {
      "description": [
          "Hari libur nasional"
      ],
      "holiday": true,
      "summary": [
          "Cuti Bersama Idul Fitri"
      ]
  },
  "2026-03-24": {
      "description": [
          "Hari libur nasional"
      ],
      "holiday": true,
      "summary": [
          "Cuti Bersama Idul Fitri"
      ]
  },
  "2026-04-03": {
      "description": [
          "Hari libur nasional"
      ],
      "holiday": true,
      "summary": [
          "Wafat Isa Almasih"
      ]
  },
  "2026-04-05": {
      "description": [
          "Hari libur nasional"
      ],
      "holiday": true,
      "summary": [
          "Hari Paskah"
      ]
  },
  "2026-05-01": {
      "description": [
          "Hari libur nasional"
      ],
      "holiday": true,
      "summary": [
          "Hari Buruh Internasional / Pekerja"
      ]
  },
  "2026-05-14": {
      "description": [
          "Hari libur nasional"
      ],
      "holiday": true,
      "summary": [
          "Kenaikan Isa Al Masih"
      ]
  },
  "2026-05-15": {
      "description": [
          "Hari libur nasional"
      ],
      "holiday": true,
      "summary": [
          "Cuti Bersama Kenaikan Isa Al Masih"
      ]
  },
  "2026-05-27": {
      "description": [
          "Hari libur nasional"
      ],
      "holiday": true,
      "summary": [
          "Idul Adha (Lebaran Haji) (belum pasti)"
      ]
  },
  "2026-05-28": {
      "description": [
          "Hari libur nasional"
      ],
      "holiday": true,
      "summary": [
          "Idul Adha (Lebaran Haji)"
      ]
  },
  "2026-05-31": {
      "description": [
          "Hari libur nasional"
      ],
      "holiday": true,
      "summary": [
          "Hari Raya Waisak (belum pasti)"
      ]
  },
  "2026-06-01": {
      "description": [
          "Hari libur nasional"
      ],
      "holiday": true,
      "summary": [
          "Hari Lahir Pancasila"
      ]
  },
  "2026-06-16": {
      "description": [
          "Hari libur nasional"
      ],
      "holiday": true,
      "summary": [
          "Satu Muharam / Tahun Baru Hijriah (belum pasti)"
      ]
  },
  "2026-08-17": {
      "description": [
          "Hari libur nasional"
      ],
      "holiday": true,
      "summary": [
          "Hari Proklamasi Kemerdekaan R.I."
      ]
  },
  "2026-08-25": {
      "description": [
          "Hari libur nasional"
      ],
      "holiday": true,
      "summary": [
          "Maulid Nabi Muhammad (belum pasti)"
      ]
  },
  "2026-12-24": {
      "description": [
          "Hari libur nasional"
      ],
      "holiday": true,
      "summary": [
          "Cuti Bersama Natal (Malam Natal)"
      ]
  },
  "2026-12-25": {
      "description": [
          "Hari libur nasional"
      ],
      "holiday": true,
      "summary": [
          "Hari Raya Natal"
      ]
  },
  "2026-12-31": {
      "description": [
          "Perayaan"
      ],
      "holiday": false,
      "summary": [
          "Malam Tahun Baru"
      ]
  }
} as const;

export const holidayDates = Object.entries(holidays)
  .filter(([_, data]) => data.holiday)
  .map(([dateString]) => new Date(dateString));

export const getHolidayInfo = (date: Date) => {
  const dateString = date.toISOString().split('T')[0];
  return (holidays as any)[dateString];
};
